import { dateUtilities } from '@incentivegames/ig-frontend-common/lib/utilities/dateUtilities';

export const dateTimeUtilities = {
  getNthDay: (day: number) => {
    const envLanguage = process.env.REACT_APP_LANGUAGE;
    const isBG = envLanguage === 'bg';
    if (isBG) {
      if ([1, 21, 31].includes(day)) return '-ви';
      if ([2, 22, 32].includes(day)) return '-ри';
      if ([7, 27, 37].includes(day) || [8, 28, 38].includes(day)) return '-ми';
      return '-ти';
    }
    return dateUtilities.getNth(day);
  },
  formatDate: (date: Date, t: any) => {
    const options: Intl.DateTimeFormatOptions = { weekday: 'long', day: 'numeric', month: 'long' };
    const locale = process.env.REACT_APP_REGION ? dateTimeUtilities.getLocaleFromRegion(process.env.REACT_APP_REGION) : 'en-UK';
    const formattedDate = new Intl.DateTimeFormat(locale, options).format(date).replace(/,\s/g, ' ');

    const [weekday, dayOfMonth, month] = formattedDate.split(' ');
    const day = parseInt(dayOfMonth, 10);
    const ordinalSuffix = t(dateTimeUtilities.getNthDay(day));

    const translatedWeekday = t(weekday.toLowerCase());
    const translatedMonth = t(month.toLowerCase());

    return { weekday: translatedWeekday, day: day, month: translatedMonth, ordinalSuffix };
  },
  getLocaleFromRegion: (region: string) => {
    const regionLocaleMap: { [key: string]: string } = {
      bg: 'bg-BG',
      ie: 'en-IE',
      ng: 'en-GB',
      nl: 'nl-NL',
      uk: 'en-GB'
    };

    return regionLocaleMap[region] || 'en-UK';
  }
};
